import type { IEvidenceStatus } from '@/types/evidence'
export const EVIDENCE_STATUS: { [K in IEvidenceStatus]: string } = {
  notApplicable: 'Not Applicable',
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  completed: 'Completed',
}

export const EVIDENCE_TABLE = {
  TITLE: 'Evidences',
  OWNER_UPDATED: 'Evidences owner updated',
  SEARCH_PLACEHOLDER: 'Search evidences...',
}
export const EVIDENCE_COLUMN_FILTER = {
  ALL: 'All',
  CLEAR: 'Clear',
  SEARCH_PLACEHOLDER: 'Search...',
  NO_RESULTS: 'No results found.',
}
export const EVIDENCE_BULK_ACTIONS = {
  SELECTED: 'selected',
  EVIDENCE: 'evidence',
  EVIDENCES: 'evidences',
  UPDATING: 'Updating...',
  CLEAR: 'Clear',
}
export const EVIDENCE_OWNER_SELECTOR = {
  SELECT_OWNER: 'Select owner',
  SEARCH_USERS: 'Search users...',
  LOADING: 'Loading...',
  NO_USER_FOUND: 'No user found.',
}
export const EVIDENCE_STATUS_SELECTOR = {
  SELECT_STATUS: 'Select status',
}
export const EVIDENCE_FILTERS = {
  ALL: 'All',
  FILTER_BY_OWNER: 'Filter by Owner',
  FILTER_BY_CLUSTER: 'Filter by Cluster',
  FILTER_BY_STANDARD: 'Filter by Standard',
}

export const EVIDENCE_DRAWER = {
  DESCRIPTION: 'Description',
  EXTERNAL_LINKS: 'External Links',
  LINKS_ADDED: 'Links Added',
  FILES: 'Files',
  RELATED_CONTROLS: 'Related Controls',
  MISSING_DESCRIPTION: 'Missing description',
  UPLOAD_FILES: 'Upload Files',
  ADD_LINK: 'Add Link',
  ADD_LINK_LABEL: 'Link Label',
  ADD_LINK_URL: 'Link URL',
  EVIDENCE_UPDATED: 'Evidence updated',
}

export const EVIDENCE_DETAIL = {
  ATTRIBUTES: 'Attributes',
  CONTENT: 'Evidence Content',
  DESCRIPTION: 'Evidence Description',
  MISSING_DESCRIPTION: 'Missing evidence description',
  RELATED_CONTROLS: 'Related Controls',
  CUSTOM_FILE_UPLOAD: 'Upload Custom File',
  ADD_CUSTOM_LINK: 'Add Custom Link',
  NO_FILES: 'No files uploaded yet',
  DOWNLOAD_CONTENT: 'Last Version',
  NEVER_UPDATED: 'Never updated',
  EVIDENCE_UPDATED: 'Evidence updated',
  CUSTOM_LINKS: 'Custom Links',
  CUSTOM_FILES: 'Custom Files',
  UPLOADED_AT: 'Uploaded at',
  FILE_NOT_FOUND: 'File not found',
  LINK_LABEL: 'Label',
  LINK_LABEL_PLACEHOLDER: 'e.g., Documentation',
  LINK_URL: 'URL',
  LINK_URL_PLACEHOLDER: 'https://example.com',
  CANCEL: 'Cancel',
  ADD_LINK: 'Add Link',
  NO_EXTERNAL_LINKS: 'No external links added',
  VIEW_IN_PLATFORM: 'View in platform',
  PLATFORM_LINK_LOCKED: "If you expand your scope you'll unlock this evidence., contact us for more information.",
}
